import packageJson from "../../../../package.json";

export const environment = {
  production: true,
  azureClientId: "3a9fb2b5-91b1-45b1-b437-d9b639727c92",
  azureTenantId: "e85a6438-8b33-4a29-b87e-9aaeffecbbf9",
  businessEnv: "staging",
  build: process.env.NX_BUILD_ID,
  branchName: process.env.NX_BRANCH_NAME,
  version: packageJson.version,
  timereportServiceUrl: "/api/timereport-service",
  timereportClientUrl:
    "https://timereport-client-staging.livelysand-af133d1c.swedencentral.azurecontainerapps.io",
  graphqlApiUrl: "/api/graphql",
  wsApiUrl: "/api/subscriptions",
  fortnoxWebUrl: "fortnox",
  sentryDsn: "https://93ee5281d1b8a44691250ef83c9aa1a7@sentry.bonliva.dev/9",
  babErpUrl: "https://erp-dev.bonliva.dev"
};
